var map = {
	"./montserrat/montserrat-bold.svg": 41497,
	"./montserrat/montserrat-regular.svg": 25236,
	"./openSans/opensans-bold.svg": 50457,
	"./openSans/opensans-extrabold.svg": 32659,
	"./openSans/opensans-italic.svg": 42456,
	"./openSans/opensans-light.svg": 13564,
	"./openSans/opensans-regular.svg": 60468,
	"./openSans/opensans-semibold.svg": 51219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50780;